export const initialState = () => ({
	accountEmailDomain: {},
	accountReplyToEmails: [],
	accountUnsubscribeContactEmails: [],
});

const state = initialState();

export default state;
